module.exports = __webpack_public_path__ + "img/avatar.0cd6468c.png";